import { Component, input, OnInit, output } from '@angular/core';
import { ClickOutside } from '@shared/directives/click-outside';
import { NgClass } from '@angular/common';
import { IFullFranchiseItem, IHome_FranchisesResponse } from '@shared/constants/models.const';
import { FranchiseIconComponent } from '@shared/components/franchise-icon/franchise-icon.component';
import { HelperService } from '../../../services/helper.service';
import { HorizontalDividerComponent } from '@shared/components/horizontal-divider/horizontal-divider.component';
import { TranslateModule } from '@ngx-translate/core';
import { E_FR_LOC } from '@shared/constants/enums.const';


@Component({
  selector: 'app-language-dropdown',
  imports: [
    ClickOutside,
    NgClass,
    FranchiseIconComponent,
    HorizontalDividerComponent,
    TranslateModule,
  ],
  templateUrl: './language-dropdown.component.html',
  styleUrl: './language-dropdown.component.scss',
})
export class LanguageDropdownComponent implements OnInit {

  franchises = input<IHome_FranchisesResponse[]>();
  frChange = output<IFullFranchiseItem>();

  isDropdownOpen = false;
  selectedFranchise: IFullFranchiseItem = {
    country: 'Global',
    'contentItemId': 0,
    'language': 'English',
    'route': E_FR_LOC.en,
    'franchiseLocalization': 'GlobalEnglish',
    'allowedContentTypes': [
      'Publication',
      'News',
      'Meeting',
      'Standard',
      'Project',
      'Jurisdiction',
      'Resource',
      'Other',
      'Folder',
      'Spotlight',
      'ImportantDates',
      'Discussion',
    ],
    'folderId': null,
  };

  constructor(
    private HELPER: HelperService,
  ) {
  }


  ngOnInit() {
    this.setSelectedFr();
    this.HELPER.$onReload
      .subscribe(() => {
        this.setSelectedFr();
      });
  }

  getFrTitle(frArr?: IHome_FranchisesResponse, frItem?: IFullFranchiseItem): string {
    const reqFrItem = (frArr && frItem)
      ? {
        ...frItem,
        country: frArr.country,
      }
      : this.selectedFranchise;
    return `${reqFrItem.country} (${reqFrItem.language})`;
  }

  setSelectedFr(): void {
    this.franchises()?.forEach((franchise) => {
      franchise.localizations.forEach((localization) => {
        if (localization.route === this.HELPER.frLoc) {
          this.selectedFranchise = {
            country: franchise.country,
            ...localization,
          };
        }
      });
    });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  clickOutside() {
    this.isDropdownOpen = false;
  }

  isCurrentFr(item: IFullFranchiseItem): boolean {
    return item.route === this.selectedFranchise?.route;
  }

  selectFr(item: IFullFranchiseItem, fr: IHome_FranchisesResponse): void {
    const frItem = {
      ...item,
      country: fr.country,
    };

    this.selectedFranchise = frItem;
    this.isDropdownOpen = false;
    this.frChange.emit(frItem);
  }

}
